<template>
  <div style="background: #f0f1f5">
    <HeaderComponent
      :pageContent="pageHeader"
      @change_language="handleHeaderClick"
    ></HeaderComponent>

    <br />
    <br />
    <br />

    <div class="container mt-4">
      <div class="row" id="cars">
        <div class="col-md-12">
          <h1 class="text-primary">PROFESSIONAL DEVELOPMENT</h1>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-md-12">
          <h3 style="font-weight: 500; color: #0c27bd">
            {{ pageContent.page_heading }}
          </h3>
        </div>
        <div class="col-md-12">
          <p class="text-primary">
            Explore a curated collection of top educational websites designed to
            support your professional journey. From practical classroom
            strategies to online courses and leadership tools, these trusted
            platforms empower educators at every stage.
          </p>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-3">
              <a
                href="https://www.edutopia.org"
                target="_blank"
              >
                <img
                  src="assets/images/online-courses/Edutopia.png"
                  alt="chase"
                  class="img-fluid d-block mx-auto"
                />
                <div
                  class="bg-white p-2"
                  style="background: white; border-radius: 0px 0px 15px 15px"
                >
                  <p class="text-center">
                    A trusted resource for K–12 educators offering
                    research-based strategies, classroom tips, and stories that
                    inspire innovation and meaningful learning.
                  </p>
                  <a href="https://www.edutopia.org" target="_blank">
                    <button class="btn btn-primary mx-auto d-block my-3">
                      Visit Website
                    </button>
                  </a>
                </div>
              </a>
            </div>

            <div class="col-md-3">
              <a
                href="https://www.cultofpedagogy.com"
                target="_blank"
              >
                <img
                  src="assets/images/online-courses/Cult.png"
                  alt="chase"
                  class="img-fluid d-block mx-auto"
                />
                <div
                  class="bg-white p-2"
                  style="background: white; border-radius: 0px 0px 15px 15px"
                >
                  <p class="text-center">
                    An insightful blog and podcast led by educator Jennifer
                    Gonzalez, providing practical teaching tips, classroom
                    strategies, and professional development tools.
                  </p>
                  <a href="https://www.cultofpedagogy.com" target="_blank">
                    <button class="btn btn-primary mx-auto d-block my-3">
                      Visit Website
                    </button>
                  </a>
                </div>
              </a>
            </div>

            <div class="col-md-3">
              <a
                href="https://www.ascd.org"
                target="_blank"
              >
                <img
                  src="assets/images/online-courses/ascd.png"
                  alt="chase"
                  class="img-fluid d-block mx-auto"
                />
                <div
                  class="bg-white p-2"
                  style="background: white; border-radius: 0px 0px 15px 15px"
                >
                <p class="text-center">
                  Association for Supervision and Curriculum Development offers
                  professional development, educational leadership resources,
                  and actionable research.
                </p>
                  <a href="https://www.ascd.org" target="_blank">
                    <button class="btn btn-primary mx-auto d-block my-3">
                      Visit Website
                    </button>
                  </a>
                </div>
              </a>
            </div>
            <div class="col-md-3">
              <a
                href="https://www.ascd.org"
                target="_blank"
              >
                <img
                  src="assets/images/online-courses/Coursera.png"
                  alt="chase"
                  class="img-fluid d-block mx-auto"
                />
                <div
                  class="bg-white p-2"
                  style="background: white; border-radius: 0px 0px 15px 15px"
                >
                <p class="text-center">
                  An online learning platform offering a wide range of
                  education-focused courses and certifications from top
                  universities and institutions around the world.
                </p>
                  <a href="https://www.ascd.org" target="_blank">
                    <button class="btn btn-primary mx-auto d-block my-3">
                      Visit Website
                    </button>
                  </a>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <br /><br />
      <div class="row">
        <div class="col-md-12">
          <h3 style="color: #0c27bd">Online Courses</h3>
          <br />
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 mb-3">
          <img src="assets/images/online-courses/vid.gif" class="img-fluid" />
        </div>
        <div class="col-md-5 offset-md-1 online-courses-container">
          <br />
          <br />
          <div class="d-flex flex-row flex-wrap financial-container">
            <!-- Make it scroll to the sections  -->
            <div class="col-6 col-md-6 d-flex mb-3">
              <a
                href="https://www.open.edu/openlearn/course/view.php"
                class="grid"
                target="_blank"
              >
                <figure class="effect-zoe">
                  <img
                    src="assets/images/online-courses/1.png"
                    alt="chase"
                    class="img-fluid"
                  />
                  <figcaption>
                    <p class="description">
                      {{ pageContent.course_1 }}
                    </p>
                  </figcaption>
                </figure>
              </a>
            </div>
            <div class="col-6 col-md-6 d-flex mb-3">
              <a
                href="https://www.upou.edu.ph/news/upou-s-free-online-courses-will-train-teachers-in-online-teaching/?"
                class="grid"
                target="_blank"
              >
                <figure class="effect-zoe">
                  <img
                    src="assets/images/online-courses/2.png"
                    alt="chase"
                    class="img-fluid"
                  />
                  <figcaption>
                    <p class="description" style="bottom: 3rem">
                      {{ pageContent.course_2 }}
                    </p>
                  </figcaption>
                </figure>
              </a>
            </div>
            <div class="col-6 col-md-6 d-flex mb-3">
              <a
                href="https://www.futurelearn.com/subjects/teaching-courses"
                class="grid"
                target="_blank"
              >
                <figure class="effect-zoe">
                  <img
                    src="assets/images/online-courses/3.png"
                    alt="chase"
                    class="img-fluid"
                  />
                  <figcaption>
                    <p class="description" style="bottom: 4em">
                      {{ pageContent.course_3 }}
                    </p>
                  </figcaption>
                </figure>
              </a>
            </div>
            <div class="col-6 col-md-6 d-flex mb-3">
              <a
                href="https://teachersfirst.org/ok2ask/"
                class="grid"
                target="_blank"
              >
                <figure class="effect-zoe">
                  <img
                    src="assets/images/online-courses/4.png"
                    alt="chase"
                    class="img-fluid"
                  />
                  <figcaption>
                    <p class="description" style="bottom: 4em; font-size: 80%">
                      {{ pageContent.course_4 }}
                    </p>
                  </figcaption>
                </figure>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br />
    <br />
    <br />
    <br />
    <br />
    <FooterComponent :pageContent="pageFooter"></FooterComponent>
  </div>
</template>
 <script>
// @ is an alias to /src
import HeaderComponent from "@/components/HeaderComponent.vue";
import FooterComponent from "@/components/FooterComponent.vue";
import globalMixins from "@/plugins/globalMixins";

export default {
  name: "Classroom Management",
  components: {
    HeaderComponent,
    FooterComponent,
  },
  data() {
    return {
      pageContent: [],
      pageHeader: [],
      pageFooter: [],
      showModal: false,
      videoUrl: "",
      videos: [
        {
          id: 1,
          title: "Teaching Methods for Inspiring the Students of the Future",
          url: "https://www.youtube.com/embed/UCFg9bcW7Bk?si=l12Dg3ipogZddcJc",
          image: "/assets/images/classroom-management/1.png",
          description:
            "Collaboration, communication, critical thinking, and creativity—essential elements in every classroom.",
        },
        {
          id: 2,
          title: "Becoming a Better Teacher",
          url: "https://www.youtube.com/embed/fdZkmbY0HB0?si=AT1mje-zJHWYgMcE",
          image: "/assets/images/classroom-management/2.png",
          description:
            "In the TEDx talk 'Becoming a Better Teacher,' Mariappan Jawaharlal discusses fostering curiosity and critical thinking.",
        },
        {
          id: 3,
          title: "Cultivating Intrinsic Motivation and Creativity",
          url: "https://www.youtube.com/embed/v2eRnhBvI_I?si=iz2fe-Xt2s1c_OgL",
          image: "/assets/images/classroom-management/3.png",
          description:
            "Beth Hennessey emphasizes the importance of fostering curiosity and self-driven learning in the classroom.",
        },
      ],
    };
  },
  mounted() {
    const storedLanguage = localStorage.getItem("language");
    if (storedLanguage) {
      this.language = storedLanguage;
    }
    this.convertLanguage();
  },
  methods: {
    openModal(url) {
      console.log(url);
      this.videoUrl = url;
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
      this.videoUrl = "";
    },
    handleHeaderClick() {
      this.convertLanguage();
    },
    async convertLanguage() {
      const storedLanguage = localStorage.getItem("language");
      if (storedLanguage) {
        this.language = storedLanguage;
      }

      let lang = this.language;
      if (lang === "us") {
        lang = "en";
      }

      console.log("Updated content:", lang);

      const converted = globalMixins.online_course[lang];

      const pageHeader = globalMixins.pageHeader[lang];

      const pageFooter = globalMixins.pageFooter[lang];

      if (converted) {
        this.pageContent = {
          ...this.pageContent,
          ...converted,
        };

        this.pageHeader = {
          ...this.pageHeader,
          ...pageHeader,
        };

        this.pageFooter = {
          ...this.pageFooter,
          ...pageFooter,
        };
      }
    },
  },
};
</script>

<style scoped>
.online-courses-container {
  margin-top: -50px;
}
.grid {
  margin: 0;
  padding: 0;
}
.grid figure:hover {
  background: #2881f4;
}

.grid figure:hover img {
  background: #2881f4;
  opacity: 0 !important;
}

.grid figure img {
  position: relative;
  display: block;
  min-height: 100%;
  max-width: 100%;
  opacity: 1;
}

.grid figure figcaption {
  padding: 2em;
  color: #fff;
  text-transform: uppercase;
  font-size: 1.25em;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.grid figure figcaption::before,
.grid figure figcaption::after {
  pointer-events: none;
}

.grid figure figcaption,
.grid figure figcaption > a {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

/* Anchor will cover the whole item by default */
/* For some effects it will show as a button */
.grid figure figcaption > a {
  z-index: 1000;
  text-indent: 200%;
  white-space: nowrap;
  font-size: 0;
  opacity: 0;
}

.grid figure h2 {
  word-spacing: -0.15em;
  font-weight: 300;
}

.grid figure h2 span {
  font-weight: 800;
}

.grid figure h2,
.grid figure p {
  margin: 0;
}

.grid figure p {
  letter-spacing: 1px;
  font-size: 68.5%;
}
/*---------------*/
/***** Zoe *****/
/*---------------*/

figure.effect-zoe figcaption {
  top: auto;
  bottom: auto;
  padding: 1em;
  height: 4em;
  color: #3c4a50;
  -webkit-transition: -webkit-transform 0.35s;
  transition: transform 0.35s;
  -webkit-transform: translate3d(0, 100%, 0);
  transform: translate3d(0, 100%, 0);
}

figure.effect-zoe h2 {
  float: left;
}

figure.effect-zoe p.icon-links a {
  float: right;
  color: #3c4a50;
  font-size: 1.4em;
}

figure.effect-zoe:hover p.icon-links a:hover,
figure.effect-zoe:hover p.icon-links a:focus {
  color: #252d31;
}

figure.effect-zoe p.description {
  position: absolute;
  bottom: 6em;
  padding: 2em;
  color: #fff;
  background: #2881f4;
  text-transform: none;
  left: 0;
  font-size: 90%;
  opacity: 0;
  -webkit-transition: opacity 0.35s;
  transition: opacity 0.35s;
  -webkit-backface-visibility: hidden; /* Fix for Chrome 37.0.2062.120 (Mac) */
}

figure.effect-zoe h2,
figure.effect-zoe p.icon-links a {
  -webkit-transition: -webkit-transform 0.35s;
  transition: transform 0.35s;
  -webkit-transform: translate3d(0, 200%, 0);
  transform: translate3d(0, 200%, 0);
}

figure.effect-zoe p.icon-links a span::before {
  display: inline-block;
  padding: 8px 10px;
  font-family: "feathericons";
  speak: none;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-eye::before {
  content: "\e000";
}

.icon-paper-clip::before {
  content: "\e001";
}

.icon-heart::before {
  content: "\e024";
}

figure.effect-zoe h2 {
  display: inline-block;
}

figure.effect-zoe:hover p.description {
  opacity: 1;
}

figure.effect-zoe:hover figcaption,
figure.effect-zoe:hover h2,
figure.effect-zoe:hover p.icon-links a {
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}

figure.effect-zoe:hover h2 {
  -webkit-transition-delay: 0.05s;
  transition-delay: 0.05s;
}

figure.effect-zoe:hover p.icon-links a:nth-child(3) {
  -webkit-transition-delay: 0.1s;
  transition-delay: 0.1s;
}

figure.effect-zoe:hover p.icon-links a:nth-child(2) {
  -webkit-transition-delay: 0.15s;
  transition-delay: 0.15s;
}

figure.effect-zoe:hover p.icon-links a:first-child {
  -webkit-transition-delay: 0.2s;
  transition-delay: 0.2s;
}
@media (max-width: 767px) {
  .financial-container img {
    margin: 0 auto;
  }
  .online-courses-container {
    margin-top: 0px;
  }
}
</style>